export default __webpack_public_path__ + "63819f603ebe7d4a61aafd287334984c.png";